<div class="motif-skeleton-transparent-container">
  <span [class]="className()">&nbsp;</span>
</div>
